<template lang="pug">
    div(class="caption font-weight-bold primary--text") Fixed / Non Fixed
        v-radio-group(dense v-model="fixed" @change="onSelect" :readonly="readonly")
            v-radio(label="Fixed" :value="true" color="primary" )
            v-radio(label="Non Fixed" :value="false" color="primary")
</template>
<script>
export default {
    name: "FRadioVirtualAccountFixed",
    props: ["value","readonly"],
    data() {
        return {
            fixed: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
        doInitModel(values) {
            this.fixed = values;
            this.onSelect();
        },
        onSelect() {
            this.$emit("input", this.fixed);
            this.$emit("select", this.fixed);
        }
    }
};
</script>